module.exports = __webpack_public_path__ + "static/media/about-page-making.d6994d9f.jpg";